import { render, staticRenderFns } from "./BottleEdit.vue?vue&type=template&id=52b73cac&scoped=true&"
import script from "./BottleEdit.vue?vue&type=script&lang=js&"
export * from "./BottleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b73cac",
  null
  
)

export default component.exports